import CollapsibleDoubleBlock from './CollapsibleDoubleBlock';

export default CollapsibleDoubleBlock;